import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Subject, Subscription } from 'rxjs';
import compose from 'recompose/compose';
import setDisplayName from 'recompose/setDisplayName';
import i18next from 'i18next';
import { ErrorMessage as ErrorMessageEntity } from '@paysera/error-message-resolver';
import getHOCDisplayName from "../service/getHOCDisplayName";
import withComponentProps from "./withComponentProps";
import ErrorMessage from "./ErrorMessage";
import AdditionalErrorData from "../service/AdditionalErrorData";
import eventType from "../service/eventType";
import withErrorMessageState, { withErrorMessageStatePropTypes } from "./withErrorMessageState";
import withLogger, { withLoggerPropTypes } from "./withLogger";
import additionalErrorDataMessageProvider from "../service/additionalErrorDataMessageProvider";
var withErrorManager = function withErrorManager() {
  var autoErrorRendering = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var loggerName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return function (BaseComponent) {
    var ErrorManager = /*#__PURE__*/function (_PureComponent) {
      _inherits(ErrorManager, _PureComponent);
      var _super = _createSuper(ErrorManager);
      function ErrorManager(props) {
        var _this;
        _classCallCheck(this, ErrorManager);
        _this = _super.call(this, props);
        _this.state = {
          hasCapturedError: false
        };
        _this.subject = new Subject();
        _this.subscriptions = new Subscription();
        _this.dispatchErrorUnmount = _this.dispatchErrorUnmount.bind(_assertThisInitialized(_this));
        _this.dispatchSilentError = _this.dispatchSilentError.bind(_assertThisInitialized(_this));
        _this.dispatchError = _this.dispatchError.bind(_assertThisInitialized(_this));
        _this.clearError = _this.clearError.bind(_assertThisInitialized(_this));
        _this.subscribeError = _this.subscribeError.bind(_assertThisInitialized(_this));
        _this.renderError = _this.renderError.bind(_assertThisInitialized(_this));
        _this.subscriptions.add(_this.subject.subscribe(_this.eventsSubscriber.bind(_assertThisInitialized(_this))));
        return _this;
      }
      _createClass(ErrorManager, [{
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.subscriptions.unsubscribe();
        }
      }, {
        key: "componentDidCatch",
        value: function componentDidCatch(error, info) {
          var _this$props = this.props,
            errorMessageHandler = _this$props.errorMessageHandler,
            loggerHandler = _this$props.loggerHandler;
          loggerHandler.captureException(error, {
            info: info
          });
          this.setState({
            hasCapturedError: true
          });
          _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
            var t;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return i18next.loadNamespaces(['react-common']);
                case 2:
                  t = i18next.getFixedT(null, 'react-common');
                  errorMessageHandler.dispatchError(t('general_error'), error);
                case 4:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }))();
        }
      }, {
        key: "dispatchSilentError",
        value: function dispatchSilentError(message) {
          var originalError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          var dispatchedType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
          this.subject.next({
            type: eventType.error,
            message: message,
            originalError: originalError,
            dispatchedType: dispatchedType
          });
        }
      }, {
        key: "dispatchError",
        value: function dispatchError(message) {
          var originalError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          var dispatchedType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
          var loggerHandler = this.props.loggerHandler;
          var additionalData = {
            errorId: loggerHandler.captureException(originalError)
          };
          this.subject.next({
            type: eventType.error,
            message: message,
            originalError: originalError,
            dispatchedType: dispatchedType,
            additionalData: additionalData
          });
        }
      }, {
        key: "dispatchErrorUnmount",
        value: function dispatchErrorUnmount(message) {
          var originalError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
          this.dispatchError(message, originalError, type);
          this.setState({
            hasCapturedError: true
          });
        }
      }, {
        key: "clearError",
        value: function clearError() {
          this.subject.next({
            type: eventType.clear
          });
        }
      }, {
        key: "subscribeError",
        value: function subscribeError(subscriber) {
          var newSubscription = this.subject.subscribe(subscriber);
          this.subscriptions.add(newSubscription);
          return newSubscription;
        }
      }, {
        key: "eventsSubscriber",
        value: function eventsSubscriber(eventData) {
          var errorMessageHandler = this.props.errorMessageHandler;
          switch (eventData.type) {
            case eventType.error:
              {
                var message = eventData.message,
                  originalError = eventData.originalError,
                  dispatchedType = eventData.dispatchedType,
                  additionalData = eventData.additionalData;
                errorMessageHandler.dispatchError(message, originalError, dispatchedType, new AdditionalErrorData(additionalData));
                break;
              }
            case eventType.clear:
              errorMessageHandler.clearError();
              break;
            default:
              throw new Error("Unknown event type: ".concat(eventData.type));
          }
        }
      }, {
        key: "renderError",
        value: function renderError() {
          var _this$props$errorMess = this.props.errorMessageHandler,
            hasError = _this$props$errorMess.hasError,
            message = _this$props$errorMess.message,
            additionalData = _this$props$errorMess.additionalData,
            error = _this$props$errorMess.error,
            type = _this$props$errorMess.type;
          if (!hasError) {
            return null;
          }
          var providerAdditionalMessages = additionalErrorDataMessageProvider.getMessage(error, additionalData);
          if (message instanceof ErrorMessageEntity) {
            return /*#__PURE__*/React.createElement(ErrorMessage, {
              message: message.getPrimary(),
              type: type,
              additionalMessage: [].concat(_toConsumableArray(providerAdditionalMessages), _toConsumableArray(message.getSecondary()))
            });
          }
          return /*#__PURE__*/React.createElement(ErrorMessage, {
            message: message,
            type: type,
            additionalMessage: providerAdditionalMessages
          });
        }
      }, {
        key: "render",
        value: function render() {
          var _this$props2 = this.props,
            _this$props2$errorMes = _this$props2.errorMessageHandler,
            hasError = _this$props2$errorMes.hasError,
            message = _this$props2$errorMes.message,
            type = _this$props2$errorMes.type,
            additionalData = _this$props2$errorMes.additionalData,
            error = _this$props2$errorMes.error,
            _this$props2$loggerHa = _this$props2.loggerHandler,
            logError = _this$props2$loggerHa.logError,
            captureBreadcrumb = _this$props2$loggerHa.captureBreadcrumb,
            componentProps = _this$props2.componentProps;
          var hasCapturedError = this.state.hasCapturedError;
          var contextErrorHandler = {
            hasError: hasError,
            message: message,
            type: type,
            additionalData: additionalData,
            error: error,
            logError: logError,
            captureBreadcrumb: captureBreadcrumb,
            dispatchErrorUnmount: this.dispatchErrorUnmount,
            dispatchSilentError: this.dispatchSilentError,
            dispatchError: this.dispatchError,
            clearError: this.clearError,
            subscribeError: this.subscribeError,
            renderError: this.renderError
          };
          if (hasCapturedError) {
            return this.renderError();
          }
          return /*#__PURE__*/React.createElement(Fragment, null, autoErrorRendering && this.renderError(), /*#__PURE__*/React.createElement(BaseComponent, _extends({
            errorHandler: contextErrorHandler
          }, componentProps)));
        }
      }]);
      return ErrorManager;
    }(PureComponent);
    ErrorManager.propTypes = _objectSpread(_objectSpread({}, withLoggerPropTypes), withErrorMessageStatePropTypes);
    return compose(withComponentProps([]), setDisplayName(getHOCDisplayName(BaseComponent, 'withErrorManager')), withLogger(loggerName), withErrorMessageState)(ErrorManager);
  };
};
export default withErrorManager;
export var withErrorManagerPropTypes = {
  errorHandler: PropTypes.shape({
    hasError: PropTypes.bool.isRequired,
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(ErrorMessageEntity)]),
    type: PropTypes.string,
    additionalData: PropTypes.instanceOf(AdditionalErrorData),
    error: PropTypes.object,
    logError: PropTypes.func.isRequired,
    captureBreadcrumb: PropTypes.func.isRequired,
    dispatchSilentError: PropTypes.func.isRequired,
    dispatchError: PropTypes.func.isRequired,
    clearError: PropTypes.func.isRequired,
    subscribeError: PropTypes.func.isRequired,
    renderError: PropTypes.func.isRequired
  }).isRequired
};